import { mount } from './ui/app.js';
import { startStarfield } from './ui/stars.js';

if (location.protocol === 'file:') {
  const warn = document.getElementById('file-warning');
  const app = document.getElementById('app');
  if (warn) warn.hidden = false;
  if (app) app.hidden = true;
} else {
  const warn = document.getElementById('file-warning');
  if (warn) warn.hidden = true;
  startStarfield(document.getElementById('stars'));
  mount(document.getElementById('app'));
}
